module.exports = __webpack_public_path__ + "images/landing/video-previews/Teacher_demo_2x.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/landing/video-previews/Teacher_demo_2x.jpg
// module id = CLPB
// module chunks = 1